import React from 'react';
import ReactDOM from 'react-dom';
import RootApp from './App';

ReactDOM.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>,
  document.getElementById('root')
);
